import getLogger from '@ignitesales/logger-es';
import {ignite} from '@ignitesales/neuro-application';
import queryString from 'query-string';

let user = {};
ignite.setUserInfo = (key, value) => {
  user[key] = value;
};

const logger = getLogger({ module: 'saveSalesforceParameters' });
const timeout = 30000;
let parametersHaveBeenSaved = false;

export const salesforceServiceMethods = {
  updateProducts: 'updateProducts',
  sendLead: 'sendLead'
};

export const parameterAppKeys = {
  salesforceAccountId: 'salesforceAccountId',
  salesforceUserId: 'salesforceUserId',
  rmNumber: 'rmNumberParams',
  fcId: 'fcIdParams',
};

export const saveSalesforceParameters = async () => {
  const parsed = queryString.parse(window.location.search);
  const {
    accId,
    salesforceAccountId,
    salesforceUserId,
    rmNumber,
    fcId
  } = parsed;

  const toSave = [];
  const addToSave = (appkey, value) => {
    if (value) {
      toSave.push({
        appkey,
        value,
        timestamp: new Date()
      })
    }
  };
  addToSave(parameterAppKeys.salesforceAccountId, salesforceAccountId || accId);
  addToSave(parameterAppKeys.salesforceUserId, salesforceUserId);
  addToSave(parameterAppKeys.rmNumber, rmNumber);
  addToSave(parameterAppKeys.fcId, fcId);

  logger.info('Saving customer information', toSave);
  const promises = toSave.map(answer => {
    /* eslint-disable-next-line no-undef */
    return ignite.answerService.saveAnswer(answer);
  });
  await Promise.all(promises);
  parametersHaveBeenSaved = true;
  logger.info('Finished saving customer information');
};

export const hwParametersSaved = () => {
  const waitStart = Date.now();
  return new Promise( (resolve, reject) => {
    const checkIfReady = () => {
      logger.info('Checking to see if parameters have been saved');
      if (parametersHaveBeenSaved) {
        logger.info('Parameters save confirmed');
        return resolve(true);
      }
      const elapsed = Date.now() - waitStart;
      if (elapsed >= timeout) {
        return reject( new Error('Paramters have not saved yet') );
      }
      setTimeout(() => checkIfReady(), 200);
    };
    checkIfReady();
  });
};

export default saveSalesforceParameters;
